import React from 'react';
import styled from 'styled-components';
import { TextButton } from 'components/v2/buttons';
import { ReactComponent as MessageIcon } from 'images/v2/icons/svg/fill/svg/message.svg';
import EpdRoutes from 'routes/EpdRoutes';

type Props = {
  docId: string;
  /** From the document metadata: the user may open the comment log, and it has entries. */
  hasCommentLog: boolean;
};

/** Opens the comment log in a separate tab, which loads the log itself; this page does not. */
const DocumentCommentLogButton: React.FC<Props> = ({ docId, hasCommentLog }) => {
  if (!hasCommentLog) {
    return null;
  }

  return (
    <TextButton
      type="button"
      style={{ fontSize: 14, fontWeight: 500 }}
      text
      label="Comment log"
      icon={<StyledMessageIcon aria-hidden="true" />}
      onClick={() => window.open(EpdRoutes.param(EpdRoutes.dynamicFormCommentLog, ':docId', docId), '_blank', 'noopener,noreferrer')}
    />
  );
};

const StyledMessageIcon = styled(MessageIcon)`
  display: block;
  width: 12px;
  height: 12px;
  margin-right: 5px;
  color: ${(props) => props.theme.colors.primaryOrange};

  button:hover & {
    color: ${(props) => props.theme.colors.elementsButtonHover};
  }
`;

export default DocumentCommentLogButton;
